import { render, staticRenderFns } from "./PopupTrailersSelect.vue?vue&type=template&id=2cfb2c83&scoped=true&"
import script from "./PopupTrailersSelect.vue?vue&type=script&lang=js&"
export * from "./PopupTrailersSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb2c83",
  null
  
)

export default component.exports